<template>
  <div class="block-wrap home-news">
    <BlockTitle title-type="news" @onSwitchTab="onSwitchTab">
      <div @click="toList">更多动态》</div>
    </BlockTitle>
    <div class="content-wrap" v-show="activeIdx === 0">
      <div class="big-news news-1">
				<div class="swiper-container">
					<div class="swiper-wrapper">
					  <div class="swiper-slide" @click="toDetail(n)" v-for="(n, index) in newsList" :key="index">
					    <img :src="n.coverImg || tempImg" alt="" />
              <div class="big-news-info">
                <h3>
                  {{n.title}}
                </h3>
                <div class="news-info-detail">
                  <span>{{n._releaseDate}}</span>
                </div>
              </div>
					  </div>
					</div>
					<div class="swiper-pagination"></div>
				</div>
      </div>
      <div class="news-list-wrap">
        <div class="news-item hand" v-for="(n, index) in newsList" :key="index">
          <div class="news-time">
            <b>{{n._md}}  </b>
            <span>{{n._year}}</span>
          </div>
          <div class="news-title" @click="toDetail(n)">
            <div>·{{n.title}}</div>
            <div class="news-title-intro">{{n.briefIntroduction}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrap" v-show="activeIdx === 1">
      <template v-if="memList.length">
        <div class="big-news news-2">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" @click="toDetail(n)" v-for="(n, index) in memList" :key="index">
                <img :src="n.coverImg || tempImg" alt="" />
                <div class="big-news-info">
                  <h3>
                    {{n.title}}
                  </h3>
                  <div class="news-info-detail">
                    <span>{{n._releaseDate}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="news-list-wrap">
          <div class="news-item hand" v-for="(n, index) in memList" :key="index">
            <div class="news-time">
              <b>{{n._md}}</b>
              <span>{{n._year}}</span>
            </div>
            <div class="news-title" @click="toDetail(n)">
              <div>·{{n.title}}</div>
              <div class="news-title-intro">{{n.briefIntroduction}}</div>
            </div>
          </div>
        </div>
      </template>
      <Empty style="width: 100%;" v-else />
    </div>
    <!--<SplitLine />-->
    <img class="bg-img" src="../../assets/images/xwdt_bg.png" alt="">
  </div>
</template>

<script>
import router from '@/router';
import BlockTitle from "@/components/BlockTitle";
import Swiper from 'swiper';
import tempImg from '@/assets/tempImages/xw.jpg';

export default {
  data() {
    return {
      tempImg,
      activeIdx: 0
    }
  },
  props: {
    newsList: {
      type: Array,
      default() {
        return []
      }
    },
    memList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    dtBig() {
      if (this.memList.length >= 1) {
        return this.memList[0]
      }
      return {}
    },
  },
  components: {
    BlockTitle
  },
	mounted() {
    
	},
	watch: {
		newsList(nVal) {
			if (nVal.length) {
				this.$nextTick(() => {
          this.setSwiper('.news-1 .swiper-container');
        })
			}
		},
    memList(nVal) {
			if (nVal.length) {
				this.$nextTick(() => {
          this.setSwiper('.news-2 .swiper-container');
        })
			}
		}
	},
  methods: {
    setSwiper(className) {
      const opts = {
        autoplay: {
          delay: 2500,
        },
        loop: true,
        observer: true,
        observeParents:true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 允许点击小圆点跳转
        }
      }
      new Swiper(className, opts);
    },
    onSwitchTab(idx) {
      this.activeIdx = idx;
    },
    toDetail(item) {
      router.push(`/news/detail?aId=${item.id}`);
    },
    toList() {
      router.push(`/news?activeIdx=${this.activeIdx}`);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';
.block-wrap {
  padding-top: 40px;
  // background: url() no-repeat center bottom;
  // background-size: 100% 300px;
  padding-bottom: 20px;
  position: relative;

  .bg-img {
    position: absolute;
    left: 0;
    bottom: -60px;
    width: 100%;
    height: 300px;
    z-index: -1;
  }
}
.swiper-slide {
	img {
		width: 100%;
		height: 100%;
		display: block;
	}
}
.content-wrap {
  display: flex;
  height: 400px;
  margin-top: 20px;

  .big-news {
    width: 600px;
    height: 100%;
    margin-right: 20px;
    position: relative;
		
		.swiper-container {
			width: 100%;
			height: 100%;
		}

    > img {
      display: block;
      width: 100%;
      height: 100%;
    }

    .big-news-info {
      width: 100%;
      height: 110px;
      position: absolute;
      left: 0;
      bottom: 0;
      background: #000000;
      opacity: 0.5;
      padding: 16px 20px 0;

      > h3 {
        &:extend(.line2);
        height: 44px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 22px;
      }

      .news-info-detail {
        height: 49px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;

        .more {
          text-decoration: underline;
        }
      }
    }
  }

  .news-list-wrap {
    flex: 1;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;

    .news-item {
      display: flex;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .news-time {
        width: 80px;
        height: 50px;
        background: #f1f3f2;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        padding: 10px 10px 0 0;
        margin-right: 10px;

        > b {
          height: 16px;
          font-size: 20px;
          font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
          font-weight: 800;
          opacity: 0.7;
          color: #262626;
        }

        > span {
          margin-top: 6px;
          font-size: 14px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #262626;
          opacity: 0.5;
        }
      }

      .news-title {
        flex: 1;
        height: 48px;
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #131415;
        line-height: 25px;

        > div {
          &:extend(.line1);
        }
      }
      .news-title-intro {
        font-size: 13px;
        color: #999999;
        font-weight: 200;
      }
      
    }
  }
}
</style>